var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.00014C16.5 9.1659 16.4342 9.32486 16.3169 9.44207C16.1997 9.55928 16.0408 9.62512 15.875 9.62512H3.63402L8.19246 14.1828C8.25053 14.2409 8.29659 14.3098 8.32801 14.3857C8.35944 14.4615 8.37561 14.5428 8.37561 14.625C8.37561 14.7071 8.35944 14.7884 8.32801 14.8643C8.29659 14.9401 8.25053 15.0091 8.19246 15.0671C8.13439 15.1252 8.06546 15.1713 7.98959 15.2027C7.91372 15.2341 7.83241 15.2503 7.75029 15.2503C7.66817 15.2503 7.58685 15.2341 7.51098 15.2027C7.43512 15.1713 7.36618 15.1252 7.30811 15.0671L1.6833 9.44232C1.62519 9.38427 1.57909 9.31534 1.54764 9.23947C1.51619 9.1636 1.5 9.08227 1.5 9.00014C1.5 8.91801 1.51619 8.83668 1.54764 8.76081C1.57909 8.68494 1.62519 8.61601 1.6833 8.55797L7.30811 2.93315C7.42539 2.81588 7.58444 2.75 7.75029 2.75C7.91613 2.75 8.07519 2.81588 8.19246 2.93315C8.30973 3.05043 8.37561 3.20948 8.37561 3.37533C8.37561 3.54117 8.30973 3.70023 8.19246 3.8175L3.63402 8.37516H15.875C16.0408 8.37516 16.1997 8.44101 16.3169 8.55822C16.4342 8.67542 16.5 8.83439 16.5 9.00014Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.362f945403aea1bce2c47b84fe51f68c.svg";
export { ForwardRef as ReactComponent };